<template>
    <div class="row">
        <div class="col-lg-12 pb-100">
            <div class="main-title">
                <h1>Quản lý vận đơn</h1>
            </div>
            <TabNavigation @tabChange="tabChange"
                           ref="tab"
                           :tabs="tabs"/>
        </div>
    </div>
</template>

<script>
    import {$get} from "@/lib/utils";
    import TabNavigation from "../../components/TabNavigation";
    import {markRaw} from "vue";
    import DeliveryTabInfo from "./tabs/DeliveryTabInfo";
    import DeliveryTabHistory from "./tabs/DeliveryTabHistory";

    export default {
        name: "DeliveryForm",
        components: {TabNavigation},
        data() {
            return {
                tabs: [
                    {id: 'TabDeliveryInfo', name: 'Thông tin vận đơn', component: markRaw(DeliveryTabInfo)},
                    {id: 'TabDeliveryHistory', name: 'Lịch sử giao hàng' , component: markRaw(DeliveryTabHistory)}
                ],
            }
        },
        mounted() {
            document.title = 'Chỉnh sửa hóa đơn | OmiPos';
        },
        methods: {
            tabChange(tab) {
                this.currentTab = tab;
                if (this.$route.query.id) {
                    this.load();
                } else {
                    this.$refs.tab.setTabData({
                        isDataLoaded: true
                    })
                }
            },
            async load() {
                const res = await $get('/v1/deliveries/show', {
                    id: this.$route.query.id
                });

                if (res.code === 404) {
                    location.replace('/404');
                    return;
                }

                if (!res.data.entry) {
                    const indexHistory = this.tabs.findIndex(el => (el.id === "TabDeliveryHistory"));
                    this.tabs.splice(indexHistory, 1);
                }

                this.$refs.tab.setTabData({
                    entry: res.data.entry,
                    location: res.data.location,
                    listStatus: res.data.list_status,
                    listWeightUnit: res.data.list_weight_unit,
                    listTransporter: res.data.list_transporter,
                    listServiceType: res.data.list_service_type,
                    isDataLoaded: true,

                    deliveryStatus: res.data.delivery_status
                });

            }
        }
    }
</script>

<style scoped>

</style>
